import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CardConfig } from 'patternfly-ng/card';
import { WorkItemUI } from './../../models/work-item';


export class PlannerCardComponent {

   workItem: WorkItemUI;
   readonly onCardClick = new EventEmitter();
   readonly onTitleClick = new EventEmitter();

  private config: CardConfig = {
    noPadding: true,
    topBorder: false,
    titleBorder: false
  };

  cardClick(workItem: WorkItemUI, event) {
    event.stopPropagation();
    this.onCardClick.emit(workItem);
  }

  titleClick(workItem: WorkItemUI, event) {
    event.stopPropagation();
    this.onTitleClick.emit(workItem);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'f8-planner-card',
    templateUrl: './planner-card.component.html',
    styleUrls: ['./planner-card.component.less']
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'workItem': [{ type: Input },],
'onCardClick': [{ type: Output },],
'onTitleClick': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
